module.exports = __webpack_public_path__ + "img/sv87.380c95f8.svg";